import React from 'react'
import { motion } from 'framer-motion'
import { IoIosArrowForward } from 'react-icons/io'
import { itemVariants } from './data/motionData'
import bg_flow from '../assets/bg-flow.webp'
import { redirectApp } from '../../core/utils/helper'

const StartNowCard = () => {
  return (
    <div className="mx-auto flex flex-col items-center px-10 pt-20 max-w-480:pt-2 pb-20 max-w-480:pb-12 h-full w-screen relative left-1/2 right-1/2 -ml-[50vw] -mr-[50vw]">
			<div 
					className="flex flex-col items-center justify-center h-[283px] w-[70vw] min-2560:w-[60vw] max-w-480:w-[90vw] bg-cover bg-no-repeat relative rounded-[30px]"
					style={{ backgroundImage: `url(${bg_flow})` }}
			>
					<div className="flex flex-col items-center justify-center z-10">
					<h2 className="font-inter lg:text-[40px] text-[32px] font-semibold text-white text-center mb-12">
							Join Others Making the <br className='max-w-480:block max-w-430:hidden hidden'/> Most of AI-PRO
					</h2>
					<motion.button 
							className="bg-[#3073D5] hover:bg-[#2590EE] text-white pl-[20px] px-4 py-3 rounded-full transition-all duration-300 transform"
							key='Try AI-PRO Now'
							variants={itemVariants}
							initial="hidden"
							animate="visible"
							transition={{ duration: 0.4, delay: 0.2 }}
							whileTap={{ scale: 0.95 }}
							onClick={(e) => redirectApp(e, 'registration')}
					>
					<div className="flex items-center">
									Try AI-PRO Now
					<IoIosArrowForward className="ml-2 text-lg" />
					</div>
			</motion.button>
					</div>
			</div>
    </div>
  )
}

export default StartNowCard